import $ from 'jquery';

const $body = $('body');

$('.nav-trigger').on('click', event => {
  event.preventDefault();

  $body.toggleClass('nav-active');
});
